import React from 'react';
import { PageSection, SiteData } from '../../../types';
import { Image as ImageIcon, Sparkles } from 'lucide-react';
import { isDarkBackground, getOptimalTextColor } from '../../../utils/contrast';

interface SectionProps {
  section: PageSection;
  siteData: SiteData;
}

export const GallerySection: React.FC<SectionProps> = ({ section, siteData }) => {
  const content = section.content || {};
  const style = section.style || {};

  const badge = content.badge || 'FOTOĞRAF GALERİSİ';
  const title = content.title || 'Seçkin Görseller ve Anlar';
  
  // Read gallery from content or site settings
  const rawItems = content.items || (siteData.settings as any)?.galleryList || [];
  const items = Array.isArray(rawItems) ? rawItems : [];

  const bgColor = style.backgroundColor || '#FFFFFF';
  const isDark = isDarkBackground(bgColor);
  const textColor = style.textColor || getOptimalTextColor(bgColor);
  const accentColor = siteData.settings?.accentColor || '#2563EB';

  const anchorId = style.anchorId || style.customId || 'gallery';

  return (
    <section
      id={anchorId}
      data-section-id={section.id}
      data-section-type="GALLERY"
      className="py-20 px-4 sm:px-6 lg:px-8 select-none transition-colors"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="text-center max-w-2xl mx-auto space-y-3">
          {badge && (
            <div
              className="inline-flex items-center gap-1.5 px-3.5 py-1 rounded-full text-xs font-black tracking-widest uppercase border"
              style={{
                borderColor: `${accentColor}40`,
                backgroundColor: `${accentColor}10`,
                color: accentColor,
              }}
            >
              <Sparkles className="w-3 h-3" />
              <span>{badge}</span>
            </div>
          )}
          <h2 className={`text-2xl sm:text-4xl font-extrabold tracking-tight ${isDark ? 'text-white' : 'text-slate-900'}`}>
            {title}
          </h2>
        </div>

        {items.length === 0 ? (
          <div className="p-12 text-center rounded-3xl border-2 border-dashed border-slate-200 dark:border-slate-800 max-w-md mx-auto space-y-3">
            <div className="w-12 h-12 rounded-2xl bg-blue-50 dark:bg-blue-950/40 text-blue-600 flex items-center justify-center mx-auto">
              <ImageIcon className="w-6 h-6" />
            </div>
            <div className="space-y-1">
              <h3 className={`text-sm font-bold ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>Henüz Galeri Görseli Eklenmedi</h3>
              <p className="text-xs text-slate-400">
                Görsellerinizi sol panelden ekleyerek portfolyonuzu sergilemeye başlayın.
              </p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {items.map((img: any, idx: number) => (
              <div
                key={img.id || idx}
                className="aspect-square rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 group bg-slate-900 border border-slate-200/50 dark:border-slate-800"
              >
                <img
                  src={img.imageUrl}
                  alt={img.title || 'Galeri Görseli'}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  referrerPolicy="no-referrer"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

